
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.467 8.612l-7.359-7.358A.86.86 0 0021.497 1H5.144a.865.865 0 00-.865.865v30.27c0 .478.388.865.865.865h23.712a.865.865 0 00.865-.865V9.223c0-.23-.092-.45-.254-.611zm-1.755.69h-6.325V2.978l6.325 6.324zM6.009 31.27V2.73h13.648v7.438c0 .478.387.865.865.865h7.469V31.27H6.009z"}}),_c('path',{attrs:{"d":"M9.75 10.6h6.262a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm0 3.901h14.5a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm1.573 10.959l-2.212-5.518H7.959v6.763h.892v-2.634l-.088-2.828 2.216 5.462h.683l2.22-5.476-.084 2.842v2.634h.893v-6.763h-1.157m5.226 0h-2.494v6.763h.892v-2.647h1.593c.765 0 1.353-.177 1.763-.532.41-.355.615-.861.615-1.516 0-.624-.209-1.123-.629-1.501-.42-.378-1-.567-1.74-.567zm1.096 3.048c-.254.225-.62.338-1.097.338h-1.603v-2.657h1.654c.443.008.791.134 1.046.376.253.242.381.565.381.968 0 .426-.127.751-.381.975zm5.185.246c.328-.137.587-.343.778-.618.191-.275.286-.56.286-.854 0-.601-.182-1.071-.544-1.407-.362-.338-.862-.507-1.501-.507-.604 0-1.102.177-1.493.532-.392.355-.588.8-.588 1.335h.86c0-.349.111-.63.332-.843.221-.212.518-.318.889-.318.79 0 1.185.396 1.185 1.189 0 .353-.116.634-.349.841-.233.207-.551.314-.957.32h-.646v.702h.646c.455.005.803.113 1.045.324.241.211.362.512.362.906 0 .406-.11.717-.329.933-.221.217-.537.326-.952.326-.391 0-.701-.107-.934-.321-.233-.214-.349-.498-.349-.855h-.864c0 .563.199 1.017.598 1.361.398.343.914.515 1.549.515.634 0 1.15-.178 1.546-.534.397-.356.595-.838.595-1.445 0-.394-.102-.726-.304-.999-.203-.271-.49-.466-.861-.583z"}})])])
          )
        }
      }
    